/* eslint-disable no-restricted-syntax */

export { EcommApp } from './service-setup/EcommApp';
import { setupServiceInfo } from '@estee/elc-universal-utils';

setupServiceInfo(__serviceInfo__);
